let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9Mjjw")).then(() => parcelRequire('9wKvR'));